import { useState, useEffect } from 'react'

export function useMobile(initialDeviceType) {
  const [isMobile, setIsMobile] = useState(initialDeviceType)

  useEffect(() => {
    const updateDeviceType = () => {
      setIsMobile(window.innerWidth <= 899)
    }

    // Ejecutar la función inmediatamente al cargar
    updateDeviceType()

    // Agregar el evento para detectar resize
    window.addEventListener('resize', updateDeviceType)

    return () => window.removeEventListener('resize', updateDeviceType)
  }, [])

  return isMobile
}
